import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation } from 'react-query'
import deleteOrganizationMemberInviteService from 'services/settings/delete-organization-member-invite-service'
import useGetUserSettings from './use-get-user-settings'

export type UseUpdateOrganizationMemberInviteProps =
  {} & MutateApiHookType<Invite>

function useDeleteOrganizationMemberInvite({
  onSuccess,
  onError,
  onMutate,
}: UseUpdateOrganizationMemberInviteProps) {
  const { refetch } = useGetUserSettings()

  const { mutate: fetch, isLoading: pending } = useMutation(
    deleteOrganizationMemberInviteService,
    {
      onSuccess: async (data) => {
        await refetch()
        onSuccess?.(data)
      },
      onError,
      onMutate,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useDeleteOrganizationMemberInvite
